import { Vue, Component, Ref, Emit } from 'vue-property-decorator'
import AlertBanner from '@/components/common/AlertBanner/alert-banner.vue'
import { RegistryRequestGridResponse } from '@/modules/RegistryModule/services/registry-search-services.dto'
import {
    initialRequestTransferModalState, RequestTransferModalState
} from '@/modules/RegistryModule/views/requestGrid/request-transfer-modal/request-transfer-modal.model'
import { Nullable, StrictNullable } from '@/shared/types/app.types'
import RegistryRequestResource from '@/modules/RegistryModule/services/registryRequestResource'

@Component({
    components: {
        AlertBanner
    }
})
export default class RequestTransferModal extends Vue {
    @Ref() readonly requestTransferModal!: any

    @Emit('change-request-laboratory-ok')
    onChangeRequestLaboratoryOk(): RequestTransferModalState {
        return this.state
    }

    state: RequestTransferModalState
    constructor() {
        super()
        this.state = initialRequestTransferModalState()
    }

    show(request: RegistryRequestGridResponse, subrequestLabel: StrictNullable<string>): void {
        this.state = {
            center: request.physicianDepartment.center.name,
            department: request.physicianDepartment.name,
            id: request.id,
            label: request.label,
            mainPatientIdentifier: request.patient.mainPatientIdentifier,
            patient: request.patient.fullName,
            petitioner: request.physicianPetitioner.fullName,
            subrequestLabel
        }
        this.requestTransferModal.show()
    }

    async onOk(): Promise<void> {
        const response = await this.$_toCallUnique(RegistryRequestResource.bringToLaboratory(this.loggedInLaboratoryId, this.state.id))
        if (response) {
            this.onChangeRequestLaboratoryOk()
            this.hide()
        }
    }

    onCancel(): void {
        this.hide()
    }

    get loggedInLaboratoryId(): number {
        return this.$store.getters.labId
    }

    get mainPatientIdentifierTypeName(): Nullable<string> {
        return this.state.mainPatientIdentifier?.identifierType.name
    }

    get mainPatientIdentifier(): Nullable<string> {
        return this.state.mainPatientIdentifier?.paiIdentifier
    }

    hide(): void {
        this.requestTransferModal.hide()
    }
}
